import React, { useState } from 'react';
import { authService } from '../../services/auth';
import ModalPortal from '../Common/ModalPortal';
import './ForgotPasswordModal.css';

interface ForgotPasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isError, setIsError] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setMessage('Por favor, informe seu email');
      setIsError(true);
      return;
    }

    setIsLoading(true);
    setMessage('');

    try {
      await authService.forgotPassword(email);
      setMessage('Email de recuperação enviado! Verifique sua caixa de entrada.');
      setIsError(false);
      
      if (onSuccess) {
        onSuccess();
      }

      // Fechar modal após 3 segundos
      setTimeout(() => {
        onClose();
        setEmail('');
        setMessage('');
      }, 3000);

    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 
                          'Erro ao enviar email de recuperação. Tente novamente.';
      setMessage(errorMessage);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setMessage('');
    setIsError(false);
    onClose();
  };

  return (
    <ModalPortal isOpen={isOpen}>
      <div className="modal-overlay" onClick={handleClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Recuperar Senha</h2>
          <button className="close-button" onClick={handleClose}>&times;</button>
        </div>

        <div className="modal-body">
          <p className="modal-description">
            Informe seu email cadastrado e enviaremos instruções para redefinir sua senha.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="forgot-email">Email</label>
              <div className="input-wrapper">
                <input
                  type="email"
                  id="forgot-email"
                  placeholder="Digite seu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isLoading}
                />
                <span className="input-icon">📧</span>
              </div>
            </div>

            {message && (
              <div className={`message ${isError ? 'error' : 'success'}`}>
                {message}
              </div>
            )}

            <div className="modal-actions">
              <button
                type="button"
                className="cancel-btn"
                onClick={handleClose}
                disabled={isLoading}
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="submit-btn"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Enviando...
                  </>
                ) : (
                  'Enviar Instruções'
                )}
              </button>
            </div>
          </form>
        </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default ForgotPasswordModal;
